import clsx from 'clsx';
import { FormatUtils, PaletteUtils } from '@shared/utils';
import type { UsersResponse } from '@shared/api/rest/users';
import { ColorsEnum, Icon, Text } from '@shared/widgets';
import LockIcon from '@assets/icons/lock.svg';
import UserIcon from '@assets/icons/user2.svg';
import ReportIcon from '@assets/icons/report.svg';
import MailIcon from '@assets/icons/mail.svg';
import PhoneIcon from '@assets/icons/phone.svg';

interface IUserInfoHeaderProps {
  className?: string;
  user: UsersResponse;
}

export const UserInfoHeader = (props: IUserInfoHeaderProps) => {
  return (
    <div className={clsx(props.className)}>
      <div className='flex items-center p-4 bg-white dark:bg-soft-black max-[1400px]:flex-col'>
        <div className={clsx('w-2/4 p-4 self-start max-[1400px]:w-full')}>
          <div className='min-w-0 flex items-center shrink-1'>
            <div className='w-[104px] h-[104px] mr-8 flex-none overflow-hidden rounded-full flex items-center justify-center text-center select-none relative'>
              <div className='w-full h-full m-win-0 min-h-0 rounded-[inherit] bg-primary flex items-center justify-center relative z-10'>
                <Text weight='medium' size='xl' color={PaletteUtils.getColor(ColorsEnum.Black, ColorsEnum.White)}>
                  {props.user?.firstName?.split('')?.[0]}
                </Text>
              </div>
              {props.user.locked && (
                <div className='w-full h-full rounded-[inherit] bg-dark-wet-asphalt flex items-center justify-center absolute top-0 left-0 z-10'>
                  <Icon icon={<LockIcon />} color='red' />
                </div>
              )}
            </div>
            <div className={clsx(props.user.locked && 'opacity-50')}>
              {(props.user?.firstName || props.user?.lastName) && (
                <Text className='overflow-hidden text-ellipsis' weight='medium' size='2xl'>
                  {props.user.firstName} {props.user.lastName}
                </Text>
              )}
              {props.user?.userType && (
                <Text className='mt-1 opacity-60' weight='medium'>
                  {props.user.userType}
                </Text>
              )}
            </div>
          </div>
        </div>
        <div className={clsx('w-1/2 p-4 max-[1400px]:w-full', props.user.locked && 'opacity-50')}>
          <ul className='font-medium text-sm'>
            {props.user?.userName && (
              <li className='mb-2 flex items-center gap-2'>
                <Icon icon={<UserIcon />} color='primary' />
                {props.user.userName}
              </li>
            )}
            {props.user?.position && (
              <li className='mb-2 flex items-center gap-2'>
                <Icon icon={<ReportIcon width='18' height='18' />} color='primary' />
                {props.user.position}
              </li>
            )}
            {props.user?.emailAddress && (
              <li className='mb-2 flex items-center gap-2'>
                <Icon icon={<MailIcon />} color='primary' />
                {props.user.emailAddress}
              </li>
            )}
            {props.user.phoneAreaCode && props.user.phoneNumber && (
              <li className='flex items-center gap-2'>
                <Icon icon={<PhoneIcon />} color='primary' />
                {FormatUtils.toPhoneFormat(props.user.phoneAreaCode, props.user.phoneNumber)}
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
